import { render, staticRenderFns } from "./ExternalLinks.html?vue&type=template&id=4f8da93b&scoped=true&"
import script from "./ExternalLinks.js?vue&type=script&lang=js&"
export * from "./ExternalLinks.js?vue&type=script&lang=js&"
import style0 from "./ExternalLinks.scss?vue&type=style&index=0&id=4f8da93b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8da93b",
  null
  
)

export default component.exports